<template>
  <v-expansion-panels v-model="expanded" class="mt-6">
    <v-expansion-panel class="rounded">
      <v-expansion-panel-header class="header px-4">
        <h2 class="primary-header sans-serif text-center">{{ $t('form.import.history.title') }}</h2>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <platform-spinner v-if="loading" class="mx-auto mt-3" />
        <v-data-table
          v-else
          :headers="tableHeaders"
          :items="batches"
          :items-per-page="5"
          class="text-body-2"
          sort-by="createdAt"
          sort-desc
        >
          <template v-slot:[`item.createdAt`]="{ item }">
            <platform-date-display concise :date-time="item.createdAt" />
          </template>
          <template v-slot:[`item.created`]="{ item }">
            {{ getCreatedCount(item) }}
          </template>
          <template v-slot:[`item.failed`]="{ item }">
            {{ getFailedCount(item) }}
          </template>
          <template v-slot:[`item.manuallyCompleted`]="{ item }">
            {{ getManuallyCompletedCount(item) }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              class="cursor-pointer"
              @click="$emit('viewBatch', item)"
            >
              mdi-eye
            </v-icon>
          </template>
        </v-data-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import { PlatformImportBatch, PlatformImportBatchCreatedResults } from '@betterboards/shared/types/Import'
import PlatformSpinner from '@/components/shared/PlatformSpinner.vue'
import PlatformDateDisplay from '@/components/PlatformDateDisplay.vue'

export default Vue.extend({
  name: 'ImportHistoryTable',
  components: {
    PlatformSpinner,
    PlatformDateDisplay
  },
  props: {
    batches: {
      type: Array as PropType<PlatformImportBatch[]>,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      expanded: 0
    }
  },
  computed: {
    tableHeaders (): Array<{ text: string, value: string, sortable?: boolean, align?: string }> {
      return [
        { text: this.$t('form.import.history.date') as string, value: 'createdAt', sortable: true },
        { text: this.$t('form.import.history.created') as string, value: 'created', sortable: false, align: 'center' },
        { text: this.$t('form.import.history.failed') as string, value: 'failed', sortable: false, align: 'center' },
        { text: this.$t('form.import.history.manuallyCompleted') as string, value: 'manuallyCompleted', sortable: false, align: 'center' },
        { text: '', value: 'actions', sortable: false, align: 'center' }
      ]
    }
  },
  methods: {
    getCreatedCount (batch: PlatformImportBatch): number {
      const created: PlatformImportBatchCreatedResults | undefined | null = batch.created
      if (!created) {
        return 0
      }
      const companyCount = created.company?.length ?? 0
      const individualCount = created.individuals?.length ?? 0
      const committeeCount = created.committees?.length ?? 0
      return companyCount + individualCount + committeeCount
    },
    getFailedCount (batch: PlatformImportBatch): number {
      const failed = batch.failed
      if (!failed) {
        return 0
      }
      const companyCount = failed.company?.length ?? 0
      const individualCount = failed.individuals?.length ?? 0
      const committeeCount = failed.committees?.length ?? 0
      return companyCount + individualCount + committeeCount
    },
    getManuallyCompletedCount (batch: PlatformImportBatch): number {
      const completed: PlatformImportBatchCreatedResults | undefined | null = batch.manuallyCompleted
      if (!completed) {
        return 0
      }
      const companyCount = completed.company?.length ?? 0
      const individualCount = completed.individuals?.length ?? 0
      const committeeCount = completed.committees?.length ?? 0
      return companyCount + individualCount + committeeCount
    }
  }
})
</script>
